<template>
  <div class="bg-gray-default">
    <div class="container flex flex-col justify-center py-6 md:py-20">
      <h2
        v-if="data?.title"
        class="text-gray-dark mb-3 text-[25px] font-normal capitalize leading-normal tracking-wider md:mb-10 md:text-5xxl"
      >
        {{ data?.title }}
      </h2>
      <ul class="w-full">
        <li v-for="(block, idx) in data.list" :key="block.title">
          <div
            class="border-gray-elements text-gray-dark flex cursor-pointer select-none items-center justify-between border-b py-5"
            @click="toggleActive(idx)"
          >
            <div class="text-lg md:text-[27px]">
              {{ block.title }}
            </div>
            <div>
              <UiIcon
                class="h-6 w-6 text-primary"
                :name="activeItem !== idx ? 'chevron_down' : 'chevron_up'"
              />
            </div>
          </div>
          <SharedCollapseTransition>
            <ul v-show="activeItem === idx" class="py-5">
              <li v-for="item in block.list" :key="item.title" class="mb-5">
                <div class="mb-2">{{ item.title }}</div>
                <div class="content" v-html="item.text" />
              </li>
            </ul>
          </SharedCollapseTransition>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { AccordionBlockData } from "ecom-types";
defineProps<{ data: AccordionBlockData }>();
const activeItem = ref(-1);

function toggleActive(idx: number) {
  if (idx === activeItem.value) {
    activeItem.value = -1;
  } else {
    activeItem.value = idx;
  }
}
</script>

<style scoped>
.content:deep(.button) {
  @apply bg-button-primary font-futura hover:bg-button-primary-hover flex max-w-fit items-center justify-center px-[25px] py-4 text-sm uppercase text-white outline-0 transition-all;
}
.content:deep(.button.outline) {
  @apply !border-button-secondary !text-button-secondary hover:!bg-button-secondary border !bg-transparent hover:!text-white;
}
</style>
